
<template>
  <div>
    <div>
      <div class="button-selector">
        <div class="select-button" v-on:click="open_file_selector()">
          <label>{{label}}</label>
          <input v-show="false"
                 ref="file_selector"
                 v-on:change="handleFileUpload"
                 name="form__img-upload"
                 type="file"
                 accept=".png, .jpg, .jpeg, .vtt, .webp,.mp4,.m4v">
        </div>
        <span v-if="selectedFileName" class="file-name">{{selectedFileName}}</span>
        <p v-if="hasInvalidCharacters" class="error-message">
          لطفا نام فایل را ویرایش کنید (نباید شامل فاصله یا خط تیره باشد)
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageSelector',
  inheritAttrs: false,
  components: {},
  props: {
    label: String,
    resolotion: String,
    previewImage: String,
  },
  data() {
    return {
      file: null,
      selectedFileName: ''
    }
  },
  computed: {
    hasInvalidCharacters() {
      return this.selectedFileName && (
          this.selectedFileName.includes(' ') ||
          this.selectedFileName.includes('-')
      )
    }
  },
  methods: {
    handleFileUpload(e) {
      var myfile = e.target.files[0];
      if (myfile == null) {
        return
      }
      this.selectedFileName = myfile.name;
      this.$emit('update:previewImage', URL.createObjectURL(myfile))
      e.target.value = null;
      e.target.files = null;
      this.$emit('imagefile', myfile)
    },
    open_file_selector() {
      this.$refs.file_selector.click()
    },
  },
}
</script>

<style scoped>
.button-selector {
  display: inline-block;
  cursor: pointer;
}

.select-button {
  padding: 10px 20px;
  background-color: #202f48;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
  display: inline-block;
}

.select-button:hover {
  background-color: white;
  color: black;
}

label {
  margin-bottom: 0;
  cursor: pointer;
}

.file-name {
  margin-right: 20px;
  color: #ffffff;
  font-family: Arial;
}

.error-message {
  margin-right: 10px;
  margin-top: 10px;
  color: #ff0000;
  font-size: 14px;
}

</style>